module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cecb0f67f95793b26ddaea37e7ebc49a.png";